class Banner {
  constructor() {
    this.roots = document.querySelectorAll('[js-ird-banner]');
    if (!this.roots.length) {
      return;
    }

    this.mq = window.matchMedia('(min-width: 768px)');
    this.BOTTOM_OFFSET = 0;
    this.instances = [];
    this.update = this.update.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);

    this.initCursorCtas();
    this.init();
  }

  initCursorCtas() {
    this.cursorCtas = [];

    this.roots.forEach((root) => {
      root.querySelectorAll('[js-ird-banner-cta]').forEach((cta) => {
        const link = cta.closest('.ird-banner__link');
        const button = cta.querySelector('.ird-button');
        if (!link || !button) return;

        const state = {
          cta,
          link,
          button,
          active: false,
          clientX: 0,
          clientY: 0,
        };

        const renderPosition = () => {
          if (!state.active) return;
          const rect = link.getBoundingClientRect();
          const x = state.clientX - rect.left;
          const y = state.clientY - rect.top;
          const maxX = Math.max(0, rect.width - button.offsetWidth);
          const minY = Math.min(button.offsetHeight, rect.height);
          const clampedX = Math.max(0, Math.min(x, maxX));
          const clampedY = Math.max(minY, Math.min(y, rect.height));

          cta.style.setProperty('--ird-banner-cta-x', `${clampedX}px`);
          cta.style.setProperty('--ird-banner-cta-y', `${clampedY}px`);
        };

        const updatePointer = (event) => {
          state.clientX = event.clientX;
          state.clientY = event.clientY;
          renderPosition();
        };

        link.addEventListener('pointerenter', (event) => {
          state.active = true;
          updatePointer(event);
        });
        link.addEventListener('pointermove', updatePointer);
        link.addEventListener('pointerleave', () => {
          state.active = false;
        });

        state.renderPosition = renderPosition;
        this.cursorCtas.push(state);
      });
    });

    if (!this.cursorCtas.length) return;

    const updateActiveCtas = () => {
      this.cursorCtas.forEach((state) => state.renderPosition());
    };

    window.addEventListener('scroll', updateActiveCtas, { passive: true });
    window.addEventListener('resize', updateActiveCtas);
  }

  collectInstances() {
    this.instances = [];
    this.roots.forEach((root) => {
      const item = root.querySelector('[js-ird-banner-full-item]');
      const text = root.querySelector('[js-ird-banner-text]');
      if (!item || !text) return;
      this.instances.push({ item, text });
    });
  }

  resetState(text) {
    text.classList.remove('-sticky-bottom', '-at-end');
    text.style.removeProperty('--ird-banner-sticky-left');
    text.style.removeProperty('--ird-banner-sticky-width');
  }

  updateInstance(instance) {
    const { item, text } = instance;
    const rect = item.getBoundingClientRect();
    const textHeight = text.offsetHeight;
    const viewportBottom = window.innerHeight - this.BOTTOM_OFFSET;
    const startThreshold = viewportBottom - textHeight;
    const shouldStickBottom = rect.top <= startThreshold && rect.bottom > viewportBottom;
    const reachedEnd = rect.bottom <= viewportBottom;

    text.classList.toggle('-sticky-bottom', shouldStickBottom);
    text.classList.toggle('-at-end', reachedEnd);

    if (shouldStickBottom) {
      text.style.setProperty('--ird-banner-sticky-left', `${rect.left}px`);
      text.style.setProperty('--ird-banner-sticky-width', `${rect.width}px`);
      return;
    }

    text.style.removeProperty('--ird-banner-sticky-left');
    text.style.removeProperty('--ird-banner-sticky-width');
  }

  update() {
    if (!this.mq.matches) {
      this.instances.forEach(({ text }) => this.resetState(text));
      return;
    }
    this.instances.forEach((instance) => this.updateInstance(instance));
  }

  onMediaChange() {
    this.update();
  }

  init() {
    this.collectInstances();
    if (!this.instances.length) return;

    this.update();
    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.mq.addEventListener('change', this.onMediaChange);
  }
}

export default Banner;
